
<template functional>
  <vx-card class="px-4" :class="data.staticClass">
    <!-- PEKERJAAN HEAD -->
    <div class="vx-row">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <!-- Sender Details -->
        <div class="flex items-center">

          <div class="flex flex-col">
            <h5 class="mb-1">{{props.pekerjaanContent.ahsp.kode}} {{props.pekerjaanContent.ahsp.task_title}}</h5>
            <div class="flex items-center">
              <span class="mr-2">{{ props.pekerjaanContent.ahsp.pekerjaan_kelompok_nama }} -</span>
              <span>{{ props.pekerjaanContent.ahsp.pekerjaan_sub_nama }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- PEKERJAAN CONTENT -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="pekerjaan__content break-words mt-8 mb-4">C</div>
      </div>
    </div>

  </vx-card>
</template>

<script>
export default {
  props: {
    pekerjaanContent: {
      type: Object,
      required: true
    }
  }
}
</script>
